"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { useTimeout } from "usehooks-ts";
import { Tooltip } from "../Tooltip";
function ChartTooltipBase({
  hover,
  content,
  animation = "none",
  delay,
  interactive = false
}) {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const hasOpened = useRef(false);
  const hasHover = Boolean(hover);
  const left = hover ? hover.x : 0;
  const top = hover ? hover.y : 0;
  useEffect(() => {
    if (open) {
      hasOpened.current = true;
    }
  }, [open]);
  useTimeout(() => setOpen(true), delay ?? 0);
  if (!hasHover) {
    return null;
  }
  return <Tooltip anchor={anchorRef} animation={hasOpened.current ? "none" : animation} content={<div className="contents font-mono">{content}</div>} disablePointerEvents={!interactive} hoverable={interactive} key={interactive ? undefined : `${Math.round(left)}-${Math.round(top)}`} open={delay ? open : true}>
      <div className="absolute" ref={anchorRef} style={{
      left: Math.round(left),
      top: Math.round(top)
    }} />
    </Tooltip>;
}
export function ChartTooltip(props) {
  const $ = _c(3);
  const {
    hover,
    delay,
    interactive
  } = props;
  const left = hover ? hover.x : 0;
  const top = hover ? hover.y : 0;
  const t0 = delay || interactive ? `${Math.round(left)}-${Math.round(top)}` : undefined;
  let t1;
  if ($[0] !== props || $[1] !== t0) {
    t1 = <ChartTooltipBase key={t0} {...props} />;
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export default ChartTooltip;